/* My Acre option cards (2026-08-23, Claude). Behaviour for snippets/ma-option-cards.liquid.
   Three jobs:
     1. the selected ring and the note under the grid follow this option's own radio;
     2. every card thumbnail follows the OTHER options, so choosing Copper redraws all
        four stand cards in Copper and nobody has to imagine the combination;
     3. any "Commonly bought with" (.ma-ob) row listed in a card's data-ma-reveal is
        hidden unless that card is selected. The Giotto's Hexa wheel kit uses this:
        wheels fit the Hexa stand and nothing else, so showing them beside a
        bench-mounted oven is noise. Rows never listed by any card are left alone.
   Delegated off the options container and guarded against double-binding, matching the
   chosen-value script already in snippets/product-options.liquid. The radios are the
   theme's own, so variant resolution, the gallery and the price are untouched. */
(function () {
  function boot() {
    var fieldsets = document.querySelectorAll('[data-ma-cards]');
    Array.prototype.forEach.call(fieldsets, function (fs) {
      if (fs.dataset.maCardsBound) return;
      fs.dataset.maCardsBound = '1';

      var container = fs.closest('[data-product-options-container]') || document;
      var idx = parseInt(fs.getAttribute('data-ma-cards-index'), 10);
      var noteEl = fs.querySelector('[data-ma-cards-note]');
      var mapEl = fs.querySelector('[data-ma-cards-map]');
      var map = {};
      try { map = JSON.parse((mapEl && mapEl.textContent) || '{}'); } catch (e) { map = {}; }

      /* every variant id any card gates, so we only ever touch those rows */
      var gated = {};
      Array.prototype.forEach.call(fs.querySelectorAll('input[data-ma-reveal]'), function (i) {
        i.getAttribute('data-ma-reveal').split(',').forEach(function (id) {
          id = id.trim(); if (id) gated[id] = true;
        });
      });

      function obRow(id) {
        var btn = document.querySelector('[data-ma-ob-add][data-id="' + id + '"]');
        return btn ? btn.closest('.ma-ob__row') : null;
      }

      function selectedOptions() {
        var opts = [];
        var checked = container.querySelectorAll('input.ma-option-value__input:checked');
        Array.prototype.forEach.call(checked, function (i) {
          var k = parseInt(i.getAttribute('data-product-option'), 10);
          if (!isNaN(k)) opts[k] = i.value;
        });
        return opts;
      }

      function sync() {
        var opts = selectedOptions();
        Array.prototype.forEach.call(fs.querySelectorAll('[data-ma-card]'), function (card) {
          var input = card.querySelector('input');
          card.classList.toggle('is-selected', !!(input && input.checked));
          var probe = opts.slice();
          probe[idx] = card.getAttribute('data-ma-card-value');
          var url = map[probe.join('||')];
          var img = card.querySelector('img');
          /* A card carrying its own image (option_cards card.img) is deliberate and must
             not be redrawn from the variant map. Added 10 Sep 2026: the Aquascape kits put
             a scale DRAWING on the card while the variant keeps a real photograph for the
             Google feed, and without this guard the map overwrote the drawing on load. */
          if (img && img.hasAttribute('data-ma-card-img-fixed')) return;
          if (url && img && img.getAttribute('src') !== url) img.setAttribute('src', url);
        });

        var on = fs.querySelector('input:checked');
        if (noteEl) noteEl.textContent = on ? (on.getAttribute('data-ma-note') || '') : '';

        /* hide every gated row, then reveal the ones this choice owns */
        var show = {};
        if (on && on.getAttribute('data-ma-reveal')) {
          on.getAttribute('data-ma-reveal').split(',').forEach(function (id) {
            id = id.trim(); if (id) show[id] = true;
          });
        }
        Object.keys(gated).forEach(function (id) {
          var row = obRow(id);
          if (row) row.hidden = !show[id];
        });
      }

      container.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.classList && t.classList.contains('ma-option-value__input')) sync();
      });
      sync();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* the theme re-renders the buy box on some variant changes, so pick up new nodes too */
  document.addEventListener('shopify:section:load', boot);
})();